An array of executable actions linked to the candidate profile.
